<template>
  <div id="app" class="site-shell">
    <div class="ambient-grid" aria-hidden="true"></div>
    <NavBar />
    <main class="site-main">
      <router-view />
    </main>
    <Footer />
  </div>
</template>

<script>
import NavBar from "./components/NavBar";
import Footer from "./components/Footer";

export default {
  components: { NavBar, Footer },
};
</script>
